import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';
// let messages = require('./messages')

// extend('numeric', {...numeric, message: getMessage('numeric')})
// extend('required', {...required, message: getMessage('required')})
// extend('min', { ...min, message: getMessage('min')})
// extend('max', {...max, message: getMessage('max')})
// extend('email', {...email, message: getMessage('email')})

Object.keys(rules).forEach((rule) => {
	extend(rule, {
		...rules[rule], // copies rule configuration
		message: messages[rule], // assign message
	});
});

function getMessage(rule) {
	let msg = messages[rule];

	if (msg) {
		return msg;
	}

	return '{_field_} is not valid';
}
